import type { ComponentType } from 'react'

import type { FieldLayoutProps, FormLayout } from './form-layout-context'
import { StackedLayout } from './stacked-layout.tsx'

const layouts: Record<FormLayout, ComponentType<FieldLayoutProps>> = {
  stacked: StackedLayout,
}

export function getFormLayout(layout: FormLayout): ComponentType<FieldLayoutProps> {
  return layouts[layout]
}
